import { useGetOne, useRecordContext, useTranslate } from 'react-admin';
import { Box, CircularProgress, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ParameterExceptionEmpty } from '@/components/parameter/exceptions/ParameterExceptionEmpty.jsx';
import { ParameterExceptionList } from '@/components/parameter/exceptions/ParameterExceptionList.jsx';
import { withSubsetRecordIds } from '@/helpers/parameter/parameterExceptions.js';
import { normalizeParameterRecord } from '@/helpers/parameter/parameterSubsets.js';
import { parameterDetailsStyles } from '@/themes/commonStyles';

const StyledParameterDetails = styled(Box)(parameterDetailsStyles);

export const ParameterDetailsContent = () => {
    const listRecord = useRecordContext();
    const translate = useTranslate();
    const { data, isPending, error } = useGetOne('parameter', { id: listRecord?.id }, { enabled: listRecord?.id != null });

    if (!listRecord) {
        return null;
    }

    if (isPending) {
        return (
            <StyledParameterDetails>
                <Box className='parameter-details-loading'>
                    <CircularProgress size={24} />
                </Box>
            </StyledParameterDetails>
        );
    }

    if (error || !data) {
        return (
            <StyledParameterDetails>
                <Typography variant='body2'>{translate('common.errors.loadingData')}</Typography>
            </StyledParameterDetails>
        );
    }

    const parameter = normalizeParameterRecord(data);
    const subsets = withSubsetRecordIds(parameter.subsets, parameter.type, `parameter-${parameter.id}`);

    if (subsets.length === 0) {
        return (
            <StyledParameterDetails>
                <ParameterExceptionEmpty />
            </StyledParameterDetails>
        );
    }

    return (
        <StyledParameterDetails>
            <ParameterExceptionList subsets={subsets} resource={`parameter-exceptions-${parameter.id}`} />
        </StyledParameterDetails>
    );
};
